module.exports = __webpack_public_path__ + "img/wz.bb53be41.png";